var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAccountLogout = function SvgIconAccountLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.335 11.5H4v4.167h10V2.334h-10V6.5H2.335v-5c0-.46.373-.833.833-.833h11.667c.46 0 .833.373.833.833v15c0 .46-.373.834-.833.834H3.168a.833.833 0 0 1-.833-.834zm5-3.333v-2.5L11.5 9l-4.166 3.334v-2.5H.668V8.167z"
  })));
};
export default SvgIconAccountLogout;